const tags = ["Marketing and Communication", "Software Development", "Engineering", "IT", "Finance", "HR"];

export default function FrequentTags({ onTagClick, filters }) {
  
  return (
    <div className="frequent-tags">
      <span className="frequent-searches">Frequent Searches </span>
      {tags.map((tag, i) => (
        <button
          key={i}
          className={filters.jobCategory.includes(tag) ? "tag-btn active" : "tag-btn"}
          onClick={() => onTagClick(tag)}
        >
          {tag}
        </button>
      ))}
    </div>
  );
}
